import { render } from "./ProductInventoryForm.vue?vue&type=template&id=28f9c46a&ts=true"
import script from "./ProductInventoryForm.vue?vue&type=script&lang=ts"
export * from "./ProductInventoryForm.vue?vue&type=script&lang=ts"

import "./ProductInventoryForm.vue?vue&type=style&index=0&id=28f9c46a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__